module.exports = __webpack_public_path__ + "static/media/icon-payment-rejected.b2a1a08b.svg";